import React from 'react';
import { Select } from '@economic/taco';
import { VatAccount } from '../../../../types';
import useCachedQuery from '../../hooks/useCachedQuery';

export default function VatCodeDropdown({ addEmptyValue, ...props }) {
    const query = useCachedQuery('/vat-accounts', []);

    const data = query.data
        .filter((vatAccount: VatAccount) => !vatAccount.barred)
        .map(vatAccount => ({
            data: vatAccount,
            text: vatAccount.vatCode,
            summary: vatAccount.name,
            value: vatAccount.vatCode,
        }));

    return <Select emptyValue={addEmptyValue} {...props} data={data} loading={query.loading} className="w-20" />;
}
